import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListWilayah } from "@/services/getData"
import { Link, useLocation } from "react-router-dom"

const listMenu = [
  {
    name: "Wilayah",
    path: "/admin/master/wilayah",
  },
  {
    name: "Wilayah Merge",
    path: "/admin/master/wilayah-merge",
  },
]

export default function MasterWilayahPage() {
  const { pathname } = useLocation()

  const { data, isPending } = useQuery({
    queryKey: ["listWilayah"],
    queryFn: () => getListWilayah(),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                        ? "rounded-l-full"
                        : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          )
        })}
      </div>

      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
